import { render, staticRenderFns } from "./HolidayIndex.vue?vue&type=template&id=0b7f10e5"
import script from "./HolidayIndex.vue?vue&type=script&lang=ts"
export * from "./HolidayIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports